import { render, staticRenderFns } from "./DocGeneralParam.vue?vue&type=template&id=308acc92&scoped=true"
import script from "./DocGeneralParam.vue?vue&type=script&lang=js"
export * from "./DocGeneralParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308acc92",
  null
  
)

export default component.exports